<div class="actions-container">
  <a class="view-button" role="button" [attr.title]="'View'" (click)="navigateToDetails()">
    <i class="fas fa-eye"></i>
  </a>
  <!-- <a *ngIf="isFileAvailable" class="download-button" role="button" title="Download" (click)="downloadFile()">
    <i class="fas fa-download"></i>
  </a> -->
  <a *ngIf="invalid" class="view-button" [attr.title]="'Errors'" role="button">
    <i class="fas fa-exclamation-triangle"></i>
  </a>
</div>